import axios from 'axios'
import React from 'react'
import { Input } from '../../FormComponents'
import Button from './Button'

class LandingForm extends React.Component {
  constructor() {
    super()
    this.state = {
      loading: false,
      feedback: false,
      form: {
        email: {
          value: '',
          validation: false
        },
        telefone: {
          value: '',
          validation: false
        },
        empresa: {
          value: '',
          validation: false
        }
      }
    }
    this.onSubmit = this.onSubmit.bind(this)
    this.handleChange = this.handleChange.bind(this)
  }

  handleChange(event) {
    const { form } = this.state
    let inputValidation = false
    if (event.target.required && event.target.value === '') {
      inputValidation = true
    } else if (
      event.target.name === 'empresa' &&
      event.target.value.length < 1
    ) {
      inputValidation = true
    } else if (
      event.target.type === 'telefone' &&
      event.target.value.length < 10
    ) {
      inputValidation = true
    }
    const inputValue = event.target.value
    const inputName = event.target.name
    form[inputName].value = inputValue
    form[inputName].validation = inputValidation
    this.setState({ form })
  }

  onSubmit(e) {
    e.preventDefault()
    const { form } = this.state
    const { landingName } = this.props
    this.setState({ loading: true, feedback: null })
    axios
      .post('https://site-softin-back.vercel.app/api/subscribe', {
        email: form.email.value,
        telefone: form.telefone.value,
        empresa: form.empresa.value,
        tags: [landingName]
      })
      .then((response) => {
        if (response.data.success) {
          this.setState({
            loading: false,
            feedback: {
              message: response.data.message,
              type: 'success'
            }
          })
        } else {
          this.setState({
            loading: false,
            feedback: {
              message: response.data.message,
              type: 'warning'
            }
          })
        }
      })
      .catch(() => {
        this.setState({
          loading: false,
          feedback: {
            message:
              'Não foi possível realizar esta operação, tente novamente mais tarde.',
            type: 'err'
          }
        })
      })
  }

  render() {
    const { loading, feedback, form } = this.state
    const { textDecoration, buttonDescription, buttonColor } = this.props

    return (
      <form className="landing-form mb-3" onSubmit={this.onSubmit}>
        <Input
          required
          label="E-mail"
          name="email"
          type="email"
          onChange={this.handleChange}
          value={form.email.value}
          validation={form.email.validation}
          labelClassName="text-white"
        />

        <Input
          required
          label="Telefone"
          name="telefone"
          mask="(99) 999999999"
          onChange={this.handleChange}
          value={form.telefone.value}
          validation={form.telefone.validation}
          labelClassName="text-white"
        />

        <Input
          required
          label="Nome da empresa"
          name="empresa"
          onChange={this.handleChange}
          value={form.empresa.value}
          validation={form.empresa.validation}
          labelClassName="text-white"
        />

        {feedback ? (
          <div className={`alert-${feedback.type} mt-4 p-2`}>
            <p className="text-dark mb-0">{feedback.message}</p>
          </div>
        ) : null}

        <Button noFlex className={`${buttonColor} mt-4 w-100`} type="submit">
          {loading ? 'Enviando...' : buttonDescription}
        </Button>

        <h6 className="text-center text-white font-weight-normal mt-3 font-inter">
          Ao entrar em contato, você concorda com as{' '}
          <a
            href="https://app.gravittem.com/terms-of-services/"
            rel="noopener noreferrer"
            target="_blank"
            className={textDecoration}
          >
            Políticas de privacidade, Termos de uso{' '}
          </a>{' '}
          e uso de cookies.
        </h6>
      </form>
    )
  }
}

export default LandingForm



// WEBPACK FOOTER //
// ./src/components/newLayout/components/LandingForm.js